import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

console.log('API Configuration:', { BACKEND_URL, API });

class ApiService {
  constructor() {
    this.client = axios.create({
      baseURL: API,
      headers: {
        'Content-Type': 'application/json',
      },
      timeout: 15000, // 15 seconds timeout
    });

    // Add request interceptor for debugging
    this.client.interceptors.request.use(
      (config) => {
        console.log('API Request:', config.method?.toUpperCase(), config.url, config.params);
        return config;
      },
      (error) => {
        console.error('API Request Error:', error);
        return Promise.reject(error);
      }
    );

    // Add response interceptor for error handling
    this.client.interceptors.response.use(
      (response) => {
        console.log('API Response:', response.status, response.data);
        return response;
      },
      (error) => {
        console.error('API Response Error:', {
          message: error.message,
          status: error.response?.status,
          data: error.response?.data,
          url: error.config?.url
        });
        return Promise.reject(error);
      }
    );
  }

  // Casino endpoints
  async getCasinos(sortBy = 'rating', limit = 100) {
    try {
      console.log('Fetching casinos with sort:', sortBy);
      const response = await this.client.get('/casinos', {
        params: { sort: sortBy, limit }
      });
      console.log('Casinos fetched successfully:', response.data?.length, 'casinos');
      return response.data;
    } catch (error) {
      console.error('Failed to fetch casinos:', error);
      throw new Error(`Failed to fetch casinos: ${error.message}`);
    }
  }

  async getCasinoById(id) {
    try {
      const response = await this.client.get(`/casinos/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(`Failed to fetch casino: ${error.message}`);
    }
  }

  async createCasino(casinoData) {
    try {
      const response = await this.client.post('/casinos/', casinoData);
      return response.data;
    } catch (error) {
      throw new Error(`Failed to create casino: ${error.message}`);
    }
  }

  async updateCasino(id, casinoData) {
    try {
      const response = await this.client.put(`/casinos/${id}`, casinoData);
      return response.data;
    } catch (error) {
      throw new Error(`Failed to update casino: ${error.message}`);
    }
  }

  async deleteCasino(id) {
    try {
      const response = await this.client.delete(`/casinos/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(`Failed to delete casino: ${error.message}`);
    }
  }

  // Health check
  async healthCheck() {
    try {
      const response = await this.client.get('/health');
      return response.data;
    } catch (error) {
      throw new Error(`Health check failed: ${error.message}`);
    }
  }
}

export default new ApiService();